import { useAtom } from "jotai";
import { SetContainerRef } from "components/AnimatedHeaderOnScrollWrapper/types";
import { useEdmGetAllShiftsQuery } from "lib/graphql/megaSchema";
import {
  attendanceTrackerSearchFilterAtom,
  attendanceTrackerStaffGenreFilterAtom,
  attendanceTrackerStartDateFilterAtom,
} from "views/StaffSchedule/AttendanceTracker/atoms";
import { AttendanceTable } from "views/StaffSchedule/AttendanceTracker/components/AttendanceTable";
import { staffScheduleSelectedOrganizationIdAtom } from "views/StaffSchedule/atoms";
import { StaffScheduleFilters } from "views/StaffSchedule/components/StaffScheduleFilters";

type Props = {
  isScrolled: boolean;
  setContainerRef: SetContainerRef;
};

export const AttendanceTracker = ({ isScrolled, setContainerRef }: Props) => {
  const [selectedOrganizationId, setSelectedOrganizationId] = useAtom(
    staffScheduleSelectedOrganizationIdAtom,
  );
  const [startDate, setStartDate] = useAtom(
    attendanceTrackerStartDateFilterAtom,
  );
  const [selectedStaffGenre, setSelectedStaffGenre] = useAtom(
    attendanceTrackerStaffGenreFilterAtom,
  );
  const [searchInputValue, setSearchInputValue] = useAtom(
    attendanceTrackerSearchFilterAtom,
  );

  const { data: shiftsData, loading: shiftsDataLoading } =
    useEdmGetAllShiftsQuery({
      variables: {
        input: {
          from: startDate.format("YYYY-MM-DD"),
          to: startDate.endOf("month").format("YYYY-MM-DD"),
          organizationId: selectedOrganizationId,
        },
      },
      fetchPolicy: "network-only",
    });

  return (
    <div className="flex h-full flex-col gap-2">
      <StaffScheduleFilters
        isScrolled={isScrolled}
        startDate={startDate}
        selectedOrganizationId={selectedOrganizationId}
        selectedStaffGenre={selectedStaffGenre}
        searchInputValue={searchInputValue}
        setStartDate={setStartDate}
        setSelectedOrganizationId={setSelectedOrganizationId}
        setSelectedStaffGenre={setSelectedStaffGenre}
        setSearchInputValue={setSearchInputValue}
      />

      {shiftsDataLoading ? (
        <div className="bg-jutro-new-warm-gray-50 w-full flex-1 animate-pulse rounded-2xl duration-300" />
      ) : (
        <AttendanceTable
          shifts={shiftsData?.edmGetAllShifts ?? []}
          setContainerRef={setContainerRef}
          selectedStaffGenre={selectedStaffGenre}
          searchInputValue={searchInputValue}
          setSearchInputValue={setSearchInputValue}
        />
      )}
    </div>
  );
};
